import { render, staticRenderFns } from "./SkeletonList.vue?vue&type=template&id=c27c6be6&"
import script from "./SkeletonList.vue?vue&type=script&lang=js&"
export * from "./SkeletonList.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports